/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoTransactionNumber } from './HeoTransactionNumber';
import {
    HeoTransactionNumberFromJSON,
    HeoTransactionNumberFromJSONTyped,
    HeoTransactionNumberToJSON,
    HeoTransactionNumberToJSONTyped,
} from './HeoTransactionNumber';
import type { HeoItemId } from './HeoItemId';
import {
    HeoItemIdFromJSON,
    HeoItemIdFromJSONTyped,
    HeoItemIdToJSON,
    HeoItemIdToJSONTyped,
} from './HeoItemId';

/**
 * 
 * @export
 * @interface ClaimableInvoiceItem
 */
export interface ClaimableInvoiceItem {
    /**
     * 
     * @type {string}
     * @memberof ClaimableInvoiceItem
     */
    id: string;
    /**
     * 
     * @type {HeoItemId}
     * @memberof ClaimableInvoiceItem
     */
    heoItemId: HeoItemId;
    /**
     * 
     * @type {number}
     * @memberof ClaimableInvoiceItem
     */
    pricePerUnit: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimableInvoiceItem
     */
    discountedPricePerUnit: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimableInvoiceItem
     */
    discount: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimableInvoiceItem
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimableInvoiceItem
     */
    claimedQuantity: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimableInvoiceItem
     */
    productNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimableInvoiceItem
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimableInvoiceItem
     */
    productImageUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimableInvoiceItem
     */
    productThumbnailUrl: string;
    /**
     * 
     * @type {HeoTransactionNumber}
     * @memberof ClaimableInvoiceItem
     */
    invoiceNumber: HeoTransactionNumber;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimableInvoiceItem
     */
    invoiceFiled: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ClaimableInvoiceItem
     */
    invoiceCreatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ClaimableInvoiceItem
     */
    invoiceCustomerItemReference: string;
}

/**
 * Check if a given object implements the ClaimableInvoiceItem interface.
 */
export function instanceOfClaimableInvoiceItem(value: object): value is ClaimableInvoiceItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('heoItemId' in value) || value['heoItemId'] === undefined) return false;
    if (!('pricePerUnit' in value) || value['pricePerUnit'] === undefined) return false;
    if (!('discountedPricePerUnit' in value) || value['discountedPricePerUnit'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('claimedQuantity' in value) || value['claimedQuantity'] === undefined) return false;
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('productImageUrl' in value) || value['productImageUrl'] === undefined) return false;
    if (!('productThumbnailUrl' in value) || value['productThumbnailUrl'] === undefined) return false;
    if (!('invoiceNumber' in value) || value['invoiceNumber'] === undefined) return false;
    if (!('invoiceFiled' in value) || value['invoiceFiled'] === undefined) return false;
    if (!('invoiceCreatedAt' in value) || value['invoiceCreatedAt'] === undefined) return false;
    if (!('invoiceCustomerItemReference' in value) || value['invoiceCustomerItemReference'] === undefined) return false;
    return true;
}

export function ClaimableInvoiceItemFromJSON(json: any): ClaimableInvoiceItem {
    return ClaimableInvoiceItemFromJSONTyped(json, false);
}

export function ClaimableInvoiceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimableInvoiceItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'heoItemId': HeoItemIdFromJSON(json['heoItemId']),
        'pricePerUnit': json['pricePerUnit'],
        'discountedPricePerUnit': json['discountedPricePerUnit'],
        'discount': json['discount'],
        'quantity': json['quantity'],
        'claimedQuantity': json['claimedQuantity'],
        'productNumber': json['productNumber'],
        'productName': json['productName'],
        'productImageUrl': json['productImageUrl'],
        'productThumbnailUrl': json['productThumbnailUrl'],
        'invoiceNumber': HeoTransactionNumberFromJSON(json['invoiceNumber']),
        'invoiceFiled': json['invoiceFiled'],
        'invoiceCreatedAt': (new Date(json['invoiceCreatedAt'])),
        'invoiceCustomerItemReference': json['invoiceCustomerItemReference'],
    };
}

export function ClaimableInvoiceItemToJSON(json: any): ClaimableInvoiceItem {
    return ClaimableInvoiceItemToJSONTyped(json, false);
}

export function ClaimableInvoiceItemToJSONTyped(value?: ClaimableInvoiceItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'heoItemId': HeoItemIdToJSON(value['heoItemId']),
        'pricePerUnit': value['pricePerUnit'],
        'discountedPricePerUnit': value['discountedPricePerUnit'],
        'discount': value['discount'],
        'quantity': value['quantity'],
        'claimedQuantity': value['claimedQuantity'],
        'productNumber': value['productNumber'],
        'productName': value['productName'],
        'productImageUrl': value['productImageUrl'],
        'productThumbnailUrl': value['productThumbnailUrl'],
        'invoiceNumber': HeoTransactionNumberToJSON(value['invoiceNumber']),
        'invoiceFiled': value['invoiceFiled'],
        'invoiceCreatedAt': value['invoiceCreatedAt'].toISOString(),
        'invoiceCustomerItemReference': value['invoiceCustomerItemReference'],
    };
}

